module.exports = __webpack_public_path__ + "img/Bodice-Front-B6-Gd-Da-Eb.21feb709.png";